export const MANDATORY_CREW_TOTALS_INITIAL_VALUES = {
    totalMandatoryCrewCompleted: 0,
    totalMandatoryCrewDueLater: 0,
    totalMandatoryCrewDueSoon: 0,
    totalMandatoryCrewOverdue: 0,
    totalUpToDateCrew: 0,
    totalCrew: 0,
};

export const STATISTICS_PAGINATED_INITIAL_VALUES = {
    data: [],
    pagination: {
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1,
        totalCount: 0,
        maxPageSize: 10,
    },
    resultsDescription: null,
};

export const MANDATORY_STATISTICS_INITIAL_VALUES = {
    totalPathways: 0,
    completedPathways: 0,
    firstDueUTC: null,
    lastDueUTC: null,
    overduePathways: 0,
    dueSoonPathways: 0,
    dueLaterPathways: 0,
    upToDatePathways: 0,
    progress: 0,
};

export const UP_TO_DATE_CREW_STATUS_PILL_FILTER_VALUE = 'totalUpToDateCrew';
export const OVERDUE_CREW_STATUS_PILL_FILTER_VALUE = 'totalMandatoryCrewOverdue';
export const DUE_SOON_CREW_STATUS_PILL_FILTER_VALUE = 'totalMandatoryCrewDueSoon';
